import {createContext, ReactNode, useContext} from 'react';

export interface ConfirmOptions {
    // Asks the real question: 'Delete "Pick a path story"?'
    title: ReactNode;
    // What happens, and what happens to other people's copies.
    body?: ReactNode;
    // 'Delete project', never 'OK'.
    confirmLabel: string;
    // The safe choice gets a real name: 'Keep project', never 'Cancel'.
    safeLabel?: string;
    // The last step of a destructive action uses the danger style.
    danger?: boolean;
    // For big, irreversible actions: the name the person must type first.
    typeToConfirm?: string;
}

export type ConfirmFn = (options: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn | null>(null);

// A promise-based confirm that replaces window.confirm. ConfirmProvider
// (Dialog.tsx) must be mounted above.
export function useConfirm(): ConfirmFn {
    const confirm = useContext(ConfirmContext);
    if (!confirm) {
        throw new Error('ConfirmProvider is missing from the tree');
    }
    return confirm;
}
